module.exports = "<span class=\"pl-login-status\">\n<label>{{shared.loginData.credentials.username}}</label>\n<i (click)=\"settings()\" class=\"fa fa-cog pl-login-status-btn\" aria-hidden=\"true\" *ngIf=\"shared.loginData.isLoggedIn\"></i>\n<i (click)=\"logout()\" class=\"fa fa-sign-out pl-login-status-btn\" aria-hidden=\"true\" *ngIf=\"shared.loginData.isLoggedIn\"></i>\n</span>"


//////////////////
// WEBPACK FOOTER
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login-status/login-status.component.html
// module id = ../../../../../src/app/login-status/login-status.component.html
// module chunks = main